<script>
    import NPSelect2 from './np-select2.vue';

    export default {
        name: 'np-phonecode-select',
        mixins: [NPSelect2],
        props: ['countries'],
        methods: {
            // todo: change this
            getIso3ByPhoneCode: function(code) {
                let iso3 = '';
                this.countries.forEach(country => {
                    if (country.phone_code === code) {
                        iso3 = country.iso3;
                    }
                })
                return iso3;
            },
            formatSelection: function(state) {
                const country_iso = this.getIso3ByPhoneCode(state.id);
                if (country_iso && country_iso.length > 0) {
                    var img = ' <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> ';
                    return state.text + img;
                } else {
                    return state.text;
                }
            },
        }
    }
</script>
